import { useTranslation } from '@crehana/i18n';
import { CustomNextImage as Image } from '@crehana/next';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Container } from '@crehana/ui';

import downloadableHero from '../../assets/images/downloadable-hero-2.jpeg';
import localeEs from '../../i18n/localeEs';

const Hero = () => {
  const { t } = useTranslation();

  return (
    <Container full className="relative mt-72" style={{ height: 320 }}>
      <div className="w-full absolute h-full top-0 right-0 left-0 bottom-0 flex flex-col items-center justify-center">
        <Image
          src={downloadableHero}
          alt="downloadable-banner"
          className="-z-1"
          objectFit="cover"
          layout="fill"
        />
        <h1 className="font-h1 text-white mb-16">
          {t('HERO_TITLE', { defaultValue: localeEs.es.HERO_TITLE })}
        </h1>
        <p className="font-body2 text-white text-center px-32">
          {t('HERO_DESCRIPTION', {
            defaultValue: localeEs.es.HERO_DESCRIPTION,
          })}
        </p>
      </div>
    </Container>
  );
};

export default Hero;
